import { IMetaResult } from '../roundResults/store';

export interface IHoleResult extends IMetaResult {
  adjustedNet: number;
  gross: number;
  hole: number;
  net: number;
  scoreId: number;
  skinsFlightGrossParticipating: boolean;
  skinsFlightGrossWinner: boolean;
  skinsFlightNetParticipating: boolean;
  skinsFlightNetWinner: boolean;
  skinsRoundGrossParticipating: boolean;
  skinsRoundGrossWinner: boolean;
  skinsRoundNetParticipating: boolean;
  skinsRoundNetWinner: boolean;
  pinDistance: string | null;
}

export interface IAdminHoleResultsStore {
  [roundId: number]: IHoleResult[];
}

export const adminHoleResultsStore: IAdminHoleResultsStore = {};
